import { createResourceStore } from "@/lib/resource";
import type { Shop } from "./Shop";
import type { StockBatch } from "./StockBatch";
import type { Category } from "./Category";
import type { Asset } from "./Asset";

export interface Product {
  __type: "Product";
  id: string;
  name: string;
  sku?: string;
  description: string;
  category_id: string;
  type_id: string;
  featured_image: Asset;
  images: Asset[];
  quantity: number;
  selling_price: number;
  status: string;
  shopid: string;
  product_id: string;
  purchase_price: number;
  reorder_point: number;
  minimum_stock_level: number;
  maximum_stock_level: number;
  valuation_method: string;
  has_expiry_date: boolean;
  has_batch_tracking: boolean;
  created_at: string;
  updated_at: string;
  category: Category;
  shop: Shop;
  stock_batches: StockBatch[];
}

export const useProduct = createResourceStore<Product>("products", () => ({
  stats: {
    filters: {
      start_date: "",
      end_date: "",
    },
    total_sold: 0,
    top_products: [],
    top_categories: [],
    monthly_series: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    last_7_days_series: {
      days: [],
      data: [],
    },
  },
  transform: (item: Product) => {
    return {
      ...item,
      __type: "Product",
    };
  },
}));
